// @flow
import * as React from 'react'
import { TabPanel, TabContext } from '@mui/lab';
import { CardPlane } from './CardPlane'
import { makeStyles } from '@material-ui/core';
import Box from "@material-ui/core/Box";
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

const useStyles = makeStyles({
  tabPanelRoot: {
    padding: 0,
    width: '100%',
    margin: 0
  },
   container: {
    display: "flex",
    height: "100%",
    width: "100%"
  },
});

export const TabPlane = (props) => {
  const router = useRouter()
  const classes = useStyles()
  const [value, setValue] = React.useState('1')
  const { t, i18n } = useTranslation();
  const handleChange = (newValue) => {
    setValue(newValue)
  }

  const handlePay=(e )=>{
    if(e.type  === "Freemium"){
      navigate(`/`)
    }else{
      navigate(`/Pay/${e.id}`)
    }
  }
  return (
    <TabContext  value={value}>
      <div className="flex md:w-full  w-11/12 h-9 items-center select-none cursor-pointer justify-around border  rounded-md border-PrimaryC6">
        <span
          tabIndex={0}
          role="button"
          onKeyDown={() => handleChange('1')}
          onClick={() => handleChange('1')}
          className={`w-2/4 text-fontColor text text-base font-semibold flex justify-center items-center rounded-l-md   cursor-pointer  h-9 ${value === '1' && 'bg-PrimaryC6'
            }`}
        >
           {t("Price.5")}
        </span>
        <span
          tabIndex={-1}
          role="button"
          onKeyDown={() => handleChange('2')}
          onClick={() => handleChange('2')}
          className={`w-2/4 text-fontColor flex text text-base font-semibold justify-center items-center rounded-r-md  cursor-pointer h-9 ${value === '2' && 'bg-PrimaryC6'
            }`}
        >
           {t("Price.6")}
        </span>
      </div>
 
        <TabPanel className="w-full p-0 mt-5 mb-4 " value="1">
          {props.data.map((item, key)=>(
          item.duration.type === "Annually" && <CardPlane key={key} item={ item} onClick={(e) => router.push(`https://app.coimex.co/#/auth/register/exporter/${e.id}`)} />
          ))}
        </TabPanel>
        <TabPanel className="w-full p-0 mt-5 mb-4 " value="2">
        {props.data.map((item, key)=>(
            item.duration.type !== "Annually" &&  <CardPlane key={key}item={item} onClick={(e) => router.push(`https://app.coimex.co/#/auth/register/exporter/${e.id}`)} />
          ))}
        </TabPanel>
    </TabContext>
  )
}
